import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles'
import { createNote } from '../api'
import moment from 'moment'
import { DEFAULT_TIMEZONE } from '../constants'

const styles = theme => ({

})

class NoteModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      note: ''
    }
  }

  onClose = () => this.setState({note: ''}, this.props.onClose)

  save = () => {
    createNote(this.props.patient.id, {
      time: moment.utc().tz(DEFAULT_TIMEZONE),
      text: this.state.note
    }).then(newNote => {
      this.props.updateNotes(newNote)
      this.onClose()
    })
  }

  render () {
    if (!this.props.open) return null;
    return (
      <Dialog maxWidth={false} open={this.props.open} onClose={this.onClose}>
        <DialogTitle>Add New Note</DialogTitle>
        <DialogContent>
          <TextField
             value={this.state.note}
             onChange={e => this.setState({note: e.currentTarget.value})}
             fullWidth
           />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={this.save}>
            Save Note
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles)(NoteModal)



// WEBPACK FOOTER //
// ./src/components/NoteModal.js